// Public portfolio content from the CV and Patrick’s subsequent updates.
// Keep private repository URLs out of this file: everything here ships to browsers.
export const profile = {
  name: "Patrick Niyigena",
  role: "Software & AI Engineer",
  headline: "Reliable ML systems. Intelligent machines.",
  summary:
    "I build reproducible ML pipelines and AI software. I’m seeking MLOps roles, bringing a foundation in machine learning, backend development, and physical systems.",
  researchInterests: "Robot learning & foundation models",
  location: "Kigali, Rwanda",
  timezone: "UTC+2",
  email: "patrickn@andrew.cmu.edu",
  phone: "+250 786 889 609",
  github: "https://github.com/patrickniyigena",
  linkedin: "https://www.linkedin.com/in/patrick-niyigena",
  cv: "/patrick_niyigena_cv.pdf",
  url: "https://niyigena.com",
  about:
    "My path into AI started with physical systems: mechatronics, industrial automation, and embedded software. Today, I bring that engineering foundation to software, machine learning, and data pipelines. I’m pursuing an MSc in Engineering Artificial Intelligence at Carnegie Mellon University Africa, where I also work as a research assistant on river monitoring and flood-risk analysis.",
  interests:
    "I’m seeking MLOps opportunities focused on reliable ML systems, reproducible workflows, and model evaluation. My main research interests are robot learning and foundation models, and my current work explores adversarial robot learning and co-adaptation. I’m based in Kigali and open to remote roles.",
};

export const capabilities = [
  {
    title: "Software & backend",
    description: "Applications, APIs, and the data workflows behind them.",
    skills: [
      "Python",
      "FastAPI",
      "REST APIs",
      "PostgreSQL",
      "SQL",
      "Node.js",
      "React",
      "JavaScript",
      "C/C++",
      "Bash",
    ],
  },
  {
    title: "Machine learning & AI",
    description: "From model experiments to applications that use them.",
    skills: [
      "PyTorch",
      "scikit-learn",
      "Computer vision",
      "NLP",
      "GANs",
      "Model evaluation",
      "RAG",
      "LangChain",
      "AutoGen",
      "Sentence-transformers",
    ],
  },
  {
    title: "ML pipelines & infrastructure",
    description: "Reproducible processing, training, and evaluation workflows.",
    skills: [
      "Docker",
      "AWS",
      "MLflow",
      "Linux / WSL",
      "Git",
      "ETL",
      "Data validation",
    ],
  },
  {
    title: "Robotics & embedded",
    description: "Software that interacts with sensors and physical systems.",
    skills: [
      "ROS 2 Jazzy",
      "PPO / SAC / HER",
      "Sensor fusion",
      "FreeRTOS",
      "Embedded C/C++",
    ],
  },
];
export const learning = [
  "Kubernetes",
  "CI/CD",
  "Prometheus",
  "Grafana",
  "Automated monitoring",
  "AIOps",
];

export const education = [
  {
    school: "Carnegie Mellon University Africa",
    degree: "MSc, Engineering Artificial Intelligence",
    dates: "Aug 2025 — May 2027 (expected)",
    gpa: "3.69 / 4.00",
    detail:
      "Machine Learning for Engineers; Deep Learning; AI System Design; Natural Language Processing; Data Inference and Applied ML; AIOps: Continuous and Automated IT and AI Monitoring.",
  },
  {
    school: "Sakarya University of Applied Sciences",
    degree: "BEng, Mechatronics Engineering",
    dates: "Sep 2020 — Jul 2024",
    gpa: "3.40 / 4.00",
    detail:
      "An engineering foundation spanning mechanical, electrical, and software systems.",
  },
  {
    school: "Ankara Yıldırım Beyazıt University",
    degree: "Additional graduate study, Electrical & Electronics Engineering",
    dates: "Jan — May 2025 · Discontinued",
    gpa: "3.83 / 4.00",
    detail: "Additional graduate study; degree not completed.",
  },
];

export const experience = [
  {
    role: "Research Assistant",
    company: "Carnegie Mellon University Africa",
    location: "Kigali, Rwanda",
    dates: "May 2026 — Present",
    points: [
      "Design a software-based digital twin for river monitoring and flood-risk analysis, integrating hydrological and geospatial data with predictive modeling.",
      "Develop automated data-processing pipelines and reproducible workflows for preprocessing, model training, and evaluation.",
      "Investigate rainfall forecasting, river-state prediction, and computer vision for terrain and river-boundary analysis.",
    ],
  },
  {
    role: "Automation Engineer Intern",
    company: "Eta Elektroteknik",
    location: "Turkey",
    dates: "Feb — Jun 2024",
    points: [
      "Developed and tested industrial control software for Siemens S7-1200 PLCs; debugged and validated automation workflows with multidisciplinary teams.",
    ],
  },
  {
    role: "Mechatronics Engineer",
    company: "SMS İş Makinaları",
    location: "Turkey",
    dates: "May — Oct 2023",
    points: [
      "Supported R&D for aerial work platforms through SolidWorks component design, manufacturing drawings, and tolerance analysis.",
    ],
  },
  {
    role: "Embedded Systems Intern",
    company: "Work3 Teknoloji",
    location: "Turkey",
    dates: "Jan — Apr 2023",
    points: [
      "Developed C/C++ firmware, communication interfaces, and sensor data pipelines; tested and debugged microcontroller-based products.",
    ],
  },
  {
    role: "Mechatronics Intern",
    company: "MTS Mekatronik",
    location: "Turkey",
    dates: "Jun — Aug 2022",
    points: [
      "Used Python and computer vision to automate industrial workflows and supported deployment and maintenance of automation solutions.",
    ],
  },
];
export const awards = [
  "YTB Türkiye Scholarship",
  "Ranked 2nd nationwide in Rwanda Academic Excellence examinations",
  "Ranked 2nd in undergraduate Mechatronics Engineering faculty",
];
export const languages = [
  "Kinyarwanda · Native",
  "English · Advanced",
  "Turkish · C1",
  "French · A2",
];
